export default __webpack_public_path__ + "static/media/seventeen.909fc669.jpeg";